import "../../../styles/Auth/stockPopUp.css";
export default function StockViewPopup({ isOpen, onClose, stockData }) {
    if (!isOpen || !stockData) return null;

    const stock = stockData?.data;
    const product = stock?.productId;
    const purchase = stock?.purchaseId;
    const supplier = stock?.purchaseId.supplierId || {};

    return (
        <div className="purchase-payment-popup-overlay">
            <div className="purchase-payment-popup-container">

                {/* Header */}
                <div className="purchase-payment-popup-header">
                    <h2>Stock Details</h2>
                </div>

                {/* Product Details */}
                <div className="purchase-payment-popup-section">
                    <h3>Product Details</h3>
                    <div className="details-grid">
                        <div><strong>Product Name:</strong> {product?.title}</div>
                        <div><strong>Product Code:</strong> {product?.productCode}</div>
                        <div><strong>Barcode:</strong> {product?.barCode}</div>
                        <div><strong>Category:</strong> {product?.categoryId?.categoryName}</div>
                        <div><strong>Sub Category:</strong> {product?.subCategoryId?.subCategoryName || "-"}</div>
                        <div><strong>Tax %:</strong> {product?.tax}%</div>
                    </div>
                </div>

                <hr className="stock-divider" />

                {/* Stock Information */}
                <div className="purchase-payment-popup-section">
                    <h3>Stock Information</h3>
                    <div className="details-grid">
                        <div><strong>Available Stock:</strong> {product?.quantityInStock}</div>
                        <div><strong>Stock Added:</strong> {stock?.quantity}</div>
                        <div><strong>Purchase Price:</strong> ₹{stock?.purchasePrice}</div>
                        <div><strong>Selling Price:</strong> ₹{stock?.sellingPrice}</div>
                        <div><strong>Stock Status:</strong> {stock?.stockStatus}</div>
                        <div><strong>Entry Date:</strong> {stock?.createdAt ? new Date(stock.createdAt).toLocaleDateString() : "-"}</div>
                    </div>
                </div>

                <hr className="stock-divider" />

                {/* Purchase Info */}
                <div className="purchase-payment-popup-section">
                    <h3>Purchase Info</h3>
                    {purchase ? (
                        <div className="details-grid">
                            <div><strong>Invoice No:</strong> {purchase?.purchaseInvoiceNumber}</div>
                            <div><strong>Invoice Date:</strong> {purchase?.purchaseInvoiceDate ? new Date(purchase.purchaseInvoiceDate).toLocaleDateString() : "-"}</div>
                            <div><strong>Supplier:</strong> {supplier?.supplierName || '-'}</div>
                            <div><strong>Mobile:</strong> {supplier?.mobileNumber || '-'}</div>
                        </div>
                    ) : <p style={{ padding: "8px" }}>No purchase info found</p>}
                </div>

                {/* Footer */}
                <div className="purchase-payment-popup-footer">
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>

            </div>
        </div>
    );
}

